import { componentInfo as componentInfo$a } from "../blocks/accordion/component-info.qwik.mjs";
import { Accordion } from "../blocks/accordion/accordion.qwik.mjs";
import { componentInfo } from "../blocks/button/component-info.qwik.mjs";
import { Button } from "../blocks/button/button.qwik.mjs";
import { componentInfo as componentInfo$1 } from "../blocks/columns/component-info.qwik.mjs";
import { Columns } from "../blocks/columns/columns.qwik.mjs";
import { componentInfo as componentInfo$2 } from "../blocks/fragment/component-info.qwik.mjs";
import { FragmentComponent } from "../blocks/fragment/fragment.qwik.mjs";
import { componentInfo as componentInfo$3 } from "../blocks/image/component-info.qwik.mjs";
import { Image } from "../blocks/image/image.qwik.mjs";
import { componentInfo as componentInfo$8 } from "../blocks/personalization-container/component-info.qwik.mjs";
import { SDKS_SUPPORTING_PERSONALIZATION } from "../blocks/personalization-container/helpers.qwik.mjs";
import { PersonalizationContainer } from "../blocks/personalization-container/personalization-container.qwik.mjs";
import { componentInfo as componentInfo$4 } from "../blocks/section/component-info.qwik.mjs";
import { SectionComponent } from "../blocks/section/section.qwik.mjs";
import { componentInfo as componentInfo$5 } from "../blocks/slot/component-info.qwik.mjs";
import { Slot } from "../blocks/slot/slot.qwik.mjs";
import { componentInfo as componentInfo$6 } from "../blocks/symbol/component-info.qwik.mjs";
import { Symbol as Symbol$1 } from "../blocks/symbol/symbol.qwik.mjs";
import { componentInfo as componentInfo$9 } from "../blocks/tabs/component-info.qwik.mjs";
import { Tabs } from "../blocks/tabs/tabs.qwik.mjs";
import { componentInfo as componentInfo$7 } from "../blocks/text/component-info.qwik.mjs";
import { Text } from "../blocks/text/text.qwik.mjs";
import { getExtraComponents } from "./extra-components.qwik.mjs";
import { TARGET } from "./target.qwik.mjs";
const getDefaultRegisteredComponents = () => [
  {
    component: Button,
    ...componentInfo
  },
  {
    component: Columns,
    ...componentInfo$1
  },
  {
    component: FragmentComponent,
    ...componentInfo$2
  },
  {
    component: Image,
    ...componentInfo$3
  },
  {
    component: SectionComponent,
    ...componentInfo$4
  },
  {
    component: Slot,
    ...componentInfo$5
  },
  {
    component: Symbol$1,
    ...componentInfo$6
  },
  {
    component: Text,
    ...componentInfo$7
  },
  ...SDKS_SUPPORTING_PERSONALIZATION.includes(TARGET) ? [
    {
      component: PersonalizationContainer,
      ...componentInfo$8
    }
  ] : [],
  ...[
    {
      component: Tabs,
      ...componentInfo$9
    },
    {
      component: Accordion,
      ...componentInfo$a
    }
  ],
  ...getExtraComponents()
];
export {
  getDefaultRegisteredComponents
};
